import React from 'react'
import {
  useTable,
  useGlobalFilter,
  usePagination,
  useFilters,
  useSortBy,
} from "react-table";
import DotsIcon from '../../components/Icons/solid/DotsIcon';
import SearchIcon from '../../components/Icons/solid/SearchIcon';
import SelectColumnFilter from "../ReactTable/SelectColumnFilter";
import SortAscSmall from "../../components/Icons/solid/SortAscSmall";
import SortDescSmall from "../../components/Icons/solid/SortDescSmall";
import { COLORS } from "../../config";
import TableRowSubMenu from '../../components/Menus/TableRowSubMenu';
import TrashIcon from '../../components/Icons/outline/TrashIcon';


function TreatmentTransactionDetails({ setSelectedTransaction, setShowRemoveTransaction, user, allTreatmentTransactions, setShowTransactionDescription }) {

  const [showSubMenu, setShowSubMenu] = React.useState({
    active: false,
    row: null
  })


  const data = React.useMemo(
    () => [],
    
    [allTreatmentTransactions]
  );

  if (allTreatmentTransactions.length && !data.length) {
    allTreatmentTransactions.map((transaction) =>
      data.push({
        name: transaction.name,
        amount: `$${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(transaction.amount)}`,
        status: transaction.is_paid ? 'Paid' : 'Not paid'
      })
    );
  }


  const defaultColumn = React.useMemo(() => {
    return {
      Filter: SelectColumnFilter,
    };
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Item",
        accessor: "name",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Status",
        accessor: "status",
      }
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const handleRowSubMenuClick = (row) => {
    setShowSubMenu({
      active: !showSubMenu.active,
      row: row
    })
  }

  const handleViewTreatmentDescription = (row) => {
    const transactionInfo = allTreatmentTransactions[row];
    setShowSubMenu({
      active: false,
      row: null
    })
    setSelectedTransaction({
      id: transactionInfo._id,
      amount: transactionInfo.amount,
      description: transactionInfo.payment_description
    });
    setShowTransactionDescription(true)
  }

  const handleDeleteTransaction = (row) => {
    const transactionInfo = allTreatmentTransactions[row];
    setShowSubMenu({
      active: false,
      row: null
    })
    setSelectedTransaction({
      id: transactionInfo._id,
      amount: transactionInfo.amount,
    });
    setShowRemoveTransaction(true);
  }

  return (          
    <div className='w-full'>
      <div className='overflow-x-scroll'>
        <table {...getTableProps()} className='w-full mt-4 border-4 border-transparent'>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                <th className='text-left xl:px-2 pb-3 border-b-2 border-gray-100 '/>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="text-secondary xl:px-2 pb-3 border-b-2 border-gray-100 text-center text-base font-semibold"
                  >
                    <span className="flex items-center">
                      {column.render("Header")}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          
                          <SortAscSmall style={"ml-1 h-5 w-5"} />
                        ) : (
                          
                          <SortDescSmall style={"ml-1 h-5 w-5"} />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
                <th className="text-left xl:px-2 pb-3 border-b-2 border-gray-100 "></th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="">
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  className={`border-b-2 border-gray-100`}
                >
                  <td  className='text-secondary font-medium xl:px-2 py-3'/>
                  {row.cells.map((cell) => {
                    if (cell.column.id === "status") {
                      return (
                        <td
                          {...cell.getCellProps()}
                          className="text-secondary font-medium xl:px-2 py-3"
                        >
                          <span style={{ backgroundColor: cell.value === 'Paid' ? COLORS.colorLight : COLORS.colorPrimary, color:  cell.value === 'Paid' ? 'black' : COLORS.colorLight }} className={`p-2`}>{cell.render("Cell")} </span>
                        </td>
                      );
                    }
                    return (
                      <td
                        {...cell.getCellProps()}
                        className="text-gray-500 xl:px-2 py-3"
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                  <td className='text-left xl:px-2 relative'>
                    <div className='flex flex-row-reverse cursor-pointer '>
                      <DotsIcon vertical fill={COLORS.colorShade} onClick={() => handleRowSubMenuClick(row.index)}/>
                    </div>
                    {showSubMenu.active && showSubMenu.row === row.index &&
                    <TableRowSubMenu>
                      <ul className='whitespace-nowrap'>
                        <li className='cursor-pointer flex items-center m-2' onClick={() => handleViewTreatmentDescription(row.index)}>
                          <SearchIcon size='w-5 h-5' fill={COLORS.colorPrimary}/>
                          <span className='ml-3'>View description</span>
                        </li>
                        {user.user_type !== "patient"  && !allTreatmentTransactions[row.index].is_paid  &&
                        <li className='cursor-pointer flex items-center m-2' onClick={() => handleDeleteTransaction(row.index)}>
                          <TrashIcon size='w-5 h-5' stroke={COLORS.colorPrimary}/>
                          <span className='ml-3'>Delete transaction</span>
                        </li>}
                      </ul>
                    </TableRowSubMenu>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TreatmentTransactionDetails;